import { InputTypes } from "../InputTypes";

export const Status = Object.freeze({
  status: {
    visibleName: "Estado",
    type: InputTypes.TEXT_AREA,
  },
  time: {
    visibleName: "Timestamp",
    type: InputTypes.NUMBER,
  },
});
